import BaseResource from './index'

export default class RateUnitResource extends BaseResource {
    static endpoint = '/oasis/restv3/rateUnits'
}
